import { Box, useTheme } from '@mui/material'
import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'
import { ParsedEarningsAndOrdersData } from '../types/Sale'

const formatter = (value: number) => {
  if (value === 0) return '$0'
  return `$${value / 100}`
}

type Props = {
  graphData: ParsedEarningsAndOrdersData
}

const EarningsGraph = ({ graphData }: Props) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        width: '100%',
        height: '400px',
        bgcolor: theme.palette.background.paper,
        px: 3,
        pt: 2,
        pb: 8
      }}
    >
      <ResponsiveContainer
        width="100%"
        height="100%"
        style={{ fontSize: '12px' }}
      >
        <AreaChart data={graphData.earningsData}>
          <defs>
            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
              <stop
                offset="5%"
                stopColor={theme.palette.primary.main}
                stopOpacity={0.8}
              />
              <stop
                offset="95%"
                stopColor={theme.palette.primary.main}
                stopOpacity={0}
              />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            interval="preserveStart"
            dataKey={(data) => data[0]}
            tickFormatter={(date) => {
              return new Date(date).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short'
              })
            }}
          />
          <YAxis
            dataKey={1}
            tickFormatter={(value: number) => formatter(value)}
          />
          <Tooltip
            labelFormatter={(date) =>
              new Date(date).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
              })
            }
            formatter={(value: number) => formatter(value)}
            labelStyle={{ color: theme.palette.primary.main }}
          />
          <Legend />
          <Area
            name="Earnings"
            type="monotone"
            dataKey={1}
            stroke={theme.palette.primary.main}
            fill="url(#colorUv)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  )
}

export { EarningsGraph }
